/**
 * antd's theme, as tokens. This replaces the Less `modifyVars` that craco.config.js fed antd 4,
 * value for value, plus the few antd 4 derivations that antd 5 no longer makes on its own.
 */
export const antdTheme = {
    token: {
        colorPrimary: "#126dff",
        // antd 4 derived the info color from the primary one; antd 5 defaults it to #1677ff.
        colorInfo: "#126dff",
        colorLink: "#FE8065",
        // antd 5 derives a lighter hover from the link color than antd 4 did; this is antd 4's.
        colorLinkHover: "#ffa78f",
        colorSuccess: "#00F685",
        colorWarning: "#faad14",
        colorError: "#FF003D",
        borderRadius: 2,
        // antd 5 sets font-family on every component root; antd 4 let them inherit Work Sans from body.
        fontFamily:
            '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    components: {
        // antd 4's @layout-header-background also colored the sider and the dark menu; antd 5
        // defaults both to its own navy, so they are set alongside it.
        Layout: { headerBg: "#2e3135", siderBg: "#2e3135", bodyBg: "#f0f2f5" },
        Menu: {
            darkItemBg: "#2e3135",
            darkPopupBg: "#2e3135",
            darkItemColor: "#E2E8F0",
            darkItemHoverColor: "#E2E8F0",
            darkItemSelectedColor: "#E2E8F0",
        },
    },
};
